/** Поддержка: ответы на частые вопросы и кнопка связи с оператором. */
import { useEffect, useRef } from 'react';
import type { ReactElement } from 'react';
import { ActionButton } from '../components/ActionButton';
import { OfflineBanner } from '../components/States';
import { getFaq } from '../lib/faq';
import { t } from '../i18n';
import * as telegram from '../lib/telegram';
import { useActions } from '../state/actions';
import { useStore } from '../state/store';

export function Support(): ReactElement {
  const { state, dispatch } = useStore();
  const actions = useActions();

  // Ссылка на чат поддержки приходит вместе с профилем: подгружаем, если экран открыли первым.
  const requested = useRef(false);
  useEffect(() => {
    if (requested.current || state.profile) return;
    requested.current = true;
    void actions.loadProfile();
  }, [actions, state.profile]);

  const support = state.profile?.links.support ?? null;

  return (
    <>
      <h1>{t('support.title')}</h1>
      {!state.online ? <OfflineBanner /> : null}
      <p className="lead">
        {t('support.lead')}
        {support ? t('support.leadContact') : ''}
      </p>

      <div className="faq">
        {getFaq().map((item) => (
          <details key={item.question} onToggle={() => telegram.hapticFeedback.selection()}>
            <summary>{item.question}</summary>
            <div className="answer">
              {item.answer.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
            </div>
          </details>
        ))}
      </div>

      {state.user ? (
        <span className="small muted center">{t('support.id', { id: state.user.tgId })}</span>
      ) : null}

      <button
        type="button"
        className="btn ghost"
        onClick={() => dispatch({ type: 'route', screen: 'profile' })}
      >
        {t('support.back')}
      </button>

      <ActionButton
        text={t('support.write')}
        visible={support !== null}
        onClick={() => {
          if (support) telegram.openSupportChat(support);
        }}
      />
    </>
  );
}
